import { useState } from "react";
import { useCrm } from "./CrmContext";
import { Avatar, HotFlag } from "./CrmBits";
import { PIPELINE, ago, leadName, money } from "@/lib/crm";

export const PipelineBoard = () => {
  const { leads, patchLead, openPerson } = useCrm();
  const [dragging, setDragging] = useState(null);
  const [over, setOver] = useState("");
  const drop = async (stage) => {
    setOver("");
    const lead = leads.find((l) => l.id === dragging);
    setDragging(null);
    if (lead && lead.stage !== stage) await patchLead(lead.id, { stage });
  };
  const total = leads.filter((l) => PIPELINE.some((s) => s.id === l.stage) && l.stage !== "closed").reduce((sum, l) => sum + (l.deal_value || 0), 0);
  return (
    <div className="flex h-full flex-col p-4 sm:p-6" data-testid="crm-pipeline">
      <div className="mb-4 flex flex-wrap items-end justify-between gap-2">
        <div><h1 className="text-xl font-semibold tracking-tight sm:text-2xl">Deal pipeline</h1><p className="text-[12.5px] text-[#64748B]">Drag people between stages. Every move is logged to their timeline.</p></div>
        <p className="font-mono text-[13px]" data-testid="pipeline-total">Open pipeline <span className="font-semibold text-[#16A34A]">{money(total)}</span></p>
      </div>
      <div className="crm-scroll flex min-h-0 flex-1 gap-3 overflow-x-auto pb-3" data-testid="pipeline-columns">
        {PIPELINE.map((stage) => {
          const cards = leads.filter((l) => l.stage === stage.id);
          const value = cards.reduce((sum, l) => sum + (l.deal_value || 0), 0);
          return (
            <section key={stage.id} onDragOver={(e) => { e.preventDefault(); setOver(stage.id); }} onDragLeave={() => setOver("")} onDrop={() => drop(stage.id)}
              className={`flex w-[264px] shrink-0 flex-col rounded-xl border transition-colors ${over === stage.id ? "border-[#2B8FD6] bg-[#E9F4FC]" : "border-[#E2E8F0] bg-[#EEF1F6]"}`} data-testid={`pipeline-col-${stage.id}`}>
              <header className="px-3 pb-2 pt-3" style={{ boxShadow: `inset 0 3px 0 ${stage.color}` }}>
                <p className="flex items-center justify-between text-[13px] font-semibold"><span>{stage.label}</span><span className="font-mono text-[11px] text-[#64748B]" data-testid={`pipeline-count-${stage.id}`}>{cards.length}</span></p>
                <p className="font-mono text-[11px] text-[#64748B]">{money(value)}</p>
              </header>
              <div className="crm-scroll flex min-h-[120px] flex-1 flex-col gap-2 overflow-y-auto px-2 pb-2">
                {cards.map((l) => (
                  <article key={l.id} draggable onDragStart={() => setDragging(l.id)} onDragEnd={() => setDragging(null)} onClick={() => openPerson(l.id)}
                    className={`cursor-grab rounded-lg border border-[#E2E8F0] bg-white p-3 shadow-sm transition-transform duration-150 hover:-translate-y-0.5 hover:shadow-md active:cursor-grabbing ${dragging === l.id ? "opacity-50" : ""}`} data-testid={`pipeline-card-${l.id}`}>
                    <div className="flex items-start justify-between gap-2"><p className="flex items-center gap-1 text-[13px] font-semibold">{leadName(l)}<HotFlag rating={l.rating} /></p><span className="font-mono text-[12px] text-[#16A34A]">{money(l.deal_value)}</span></div>
                    <p className="mt-1 truncate text-[11.5px] text-[#64748B]">{l.address || l.source}</p>
                    <div className="mt-2.5 flex items-center justify-between"><span className="flex items-center gap-1.5 text-[11px] text-[#475569]"><Avatar name={l.assigned_agent_name || "?"} size={20} tone={l.assigned_agent_id ? "#3A4553" : "#E11D48"} />{l.assigned_agent_name?.split(" ")[0] || "Unassigned"}</span><span className="font-mono text-[10.5px] text-[#94A3B8]">{ago(l.last_contacted_at)}</span></div>
                    <select value={l.stage} onClick={(e) => e.stopPropagation()} onChange={(e) => patchLead(l.id, { stage: e.target.value })} className="mt-2 h-7 w-full rounded border border-[#E2E8F0] bg-[#F8FAFC] px-1 text-[11px] md:hidden" aria-label="Move stage" data-testid={`pipeline-move-${l.id}`}>
                      {PIPELINE.map((s) => <option key={s.id} value={s.id}>{s.label}</option>)}
                    </select>
                  </article>
                ))}
              </div>
            </section>
          );
        })}
      </div>
    </div>
  );
};
